export const messages = {
  en: {
    marketLog: {
      search: {
        title: 'Search Conditions',
        communityName: 'Community Name',
        sendWay: 'Marketing Method',
        businessType: 'Business Type',
        personNameLike: 'Marketer Name',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Marketing Records'
      },
      table: {
        logId: 'ID',
        ruleName: 'Marketing Rule',
        communityName: 'Community Name',
        personName: 'Marketer',
        personTel: 'Phone',
        openId: 'OpenId',
        sendWayName: 'Marketing Method',
        businessTypeName: 'Business Type',
        createTime: 'Send Time',
        remark: 'Remark',
        viewContent: 'View Content'
      },
      sendWay: {
        sms: 'SMS',
        wechat: 'WeChat Template Message',
        other: 'Other'
      },
      businessType: {
        accessControl: 'Access Control',
        vehicleGate: 'Vehicle Gate',
        mobilePayment: 'Mobile Payment',
        repairOrder: 'Repair Order'
      },
      viewContent: {
        title: 'Send Content',
        sendContent: 'Send Content'
      },
      fetchError: 'Failed to fetch marketing logs'
    }
  },
  zh: {
    marketLog: {
      search: {
        title: '查询条件',
        communityName: '小区名称',
        sendWay: '营销方式',
        businessType: '业务类型',
        personNameLike: '营销人',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      list: {
        title: '营销记录'
      },
      table: {
        logId: '编号',
        ruleName: '营销规则',
        communityName: '小区名称',
        personName: '营销人',
        personTel: '手机号',
        openId: 'OpenId',
        sendWayName: '营销方式',
        businessTypeName: '业务类型',
        createTime: '发送时间',
        remark: '说明',
        viewContent: '发送内容'
      },
      sendWay: {
        sms: '短信',
        wechat: '微信模板消息',
        other: '其他'
      },
      businessType: {
        accessControl: '门禁',
        vehicleGate: '车辆道闸',
        mobilePayment: '手机支付完成',
        repairOrder: '报修单提交'
      },
      viewContent: {
        title: '发送内容',
        sendContent: '发送内容'
      },
fetchError: '获取营销记录失败'
    }
  },
  'zh-TW': {
    marketLog: {
      search: {
        title: '查詢條件',
        communityName: '小區名稱',
        sendWay: '營銷方式',
        businessType: '業務類型',
        personNameLike: '營銷人',
        startTime: '開始時間',
        endTime: '結束時間'
      },
      list: {
        title: '營銷記錄'
      },
      table: {
        logId: '編號',
        ruleName: '營銷規則',
        communityName: '小區名稱',
        personName: '營銷人',
        personTel: '手機號',
        openId: 'OpenId',
        sendWayName: '營銷方式',
        businessTypeName: '業務類型',
        createTime: '發送時間',
        remark: '說明',
        viewContent: '發送內容'
      },
      sendWay: {
        sms: '短信',
        wechat: '微信模板消息',
        other: '其他'
      },
      businessType: {
        accessControl: '門禁',
        vehicleGate: '車輛道閘',
        mobilePayment: '手機支付完成',
        repairOrder: '報修單提交'
      },
      viewContent: {
        title: '發送內容',
        sendContent: '發送內容'
      },
      fetchError: '獲取營銷記錄失敗'
    }
  }
}